import React from "react";
import PureReactTable from "../common/PureReactTable";
import CardLayout from "react-lib/apps/common/CardLayout";
import { useIntl } from "react-intl";

interface CardADRNoteDetailProps {
  controller?: Record<string,any>;
  onClose?: () => void;
  patientData?: Record<string,any>;
}

const DEFAULT_PROPS = {
  controller: {},
  onClose: () => {},
  patientData: {}
}

// * Do not have their own controller
const CardADRNoteDetail = React.forwardRef<any,CardADRNoteDetailProps>((propsParam, ref) => {
  const props = {
    ...DEFAULT_PROPS,
    ...Object.fromEntries(Object.entries(propsParam).filter(([_, value])=> value !== undefined))
  }
  const [data, setData] = React.useState<any[]>([]);
  const [isLoading, setIsLoading] = React.useState(false)
  const isMounted = React.useRef(false);

  React.useEffect(() => {
    isMounted.current = true;
  }, [])

  React.useEffect(() => {
    const getADRNoteDetail = async () => {
      setIsLoading(true)
      const [response, error] = await props.controller.getAdverseReactionList({
        patientId: props.patientData.patient_id,
        today: true,
        excludeCancel: true
      });
      if (isMounted.current) {
        setIsLoading(false)
        if (response) {
          setData(response.items);
        } else {
          setData([]);
        }
      }
    };

    getADRNoteDetail();
  }, [props.patientData.patient_id]);

  return (
    <CardLayout
      titleText="รายละเอียดการบันทึก ADR ในวันนี้"
      onClose={props.onClose}
      toggleable={false}
      loading={isLoading}
    >
      <PureReactTable
        testid="adrTable"
        style={styles.table}
        className=""
        showPagination={false}
        data={data}
        minRows={0}
        columns={[
          {
            Header: "ADR",
            accessor: "status",
            Cell: row => {
              if (row.value == "NOT_KNOWN") {
                return "ไม่ทราบ";
              } else if (row.value == "NO_REACTION") {
                return "ไม่แพ้";
              } else if (row.value == "SAME_ADR") {
                return "ข้อมูลเดิม";
              } else {
                return "แพ้";
              }
            }
          },
          {
            Header: "Detail",
            accessor: "note"
          },
          {
            Header: "User",
            accessor: "edit_user"
          },
          {
            Header: "Time",
            accessor: "edited"
          }
        ]}
      />
    </CardLayout>
  );
});

CardADRNoteDetail.displayName = "CardADRNoteDetail"
const styles = {
  table: {
    height: "250px"
  }
};

export default React.memo(CardADRNoteDetail);
